import { parse, format } from 'date-fns';

export const monthLabelToParts = (label: string) => {
  const date = parse(label, 'MMMM yyyy', new Date());
  return { year: date.getFullYear(), month: date.getMonth() + 1 };
};

export const monthPartsToUTCISO = (year: number, month: number) =>
  new Date(Date.UTC(year, month - 1, 1)).toISOString();

export const monthLabelToUTCISO = (label: string) => {
  const { year, month } = monthLabelToParts(label);
  return monthPartsToUTCISO(year, month);
};

export const formatFitpassMonth = (iso: string) =>
  format(new Date(iso), 'MMMM yyyy');

export const getClientTimezoneOffset = () => new Date().getTimezoneOffset();

export const getNextMonthLabel = () => {
  const next = new Date();
  next.setMonth(next.getMonth() + 1, 1);
  return format(next, 'MMMM yyyy');
};

export const getCurrentMonthLabel = () => format(new Date(), 'MMMM yyyy');

export const getNextMonthLabelFrom = (label: string) => {
  const { year, month } = monthLabelToParts(label);
  const nextMonth =
    month === 12 ? { year: year + 1, month: 1 } : { year, month: month + 1 };
  return format(new Date(nextMonth.year, nextMonth.month - 1, 1), 'MMMM yyyy');
};

export const getCreateMonthOptions = () => {
  const months = new Set<string>();

  for (let i = 0; i < 6; i++) {
    const date = new Date();
    date.setMonth(date.getMonth() + i, 1);
    months.add(format(date, 'MMMM yyyy'));
  }

  return Array.from(months).sort(
    (a, b) => new Date(a).getTime() - new Date(b).getTime(),
  );
};

export const getFilterMonthOptions = () => {
  const months: string[] = [];

  for (let i = -4; i <= 1; i++) {
    const date = new Date();
    date.setMonth(date.getMonth() + i, 1);
    months.push(format(date, 'MMMM yyyy'));
  }

  return months;
};
